var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/arrow/chevron-down-fill",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4.5 11 8 7 11.5 11",
    transform: "translate(8.000000, 9.000000) scale(1, -1) translate(-8.000000, -9.000000)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFill);
export default __webpack_public_path__ + "static/media/chevron-down-fill.b5d474c1865d03c60707e4a98091aa09.svg";
export { ForwardRef as ReactComponent };